export function getVipDailyDownloadLimitMessage(
  downloadInfo?: ServerData.PptInfoData['downloadInfo']
): string | null {
  if (!downloadInfo || downloadInfo.canDownload !== false) {
    return null
  }

  if ((downloadInfo.vipDailyRemainDownloadCount ?? 0) > 0) {
    return null
  }

  const limit = downloadInfo.vipDailyDownloadLimit

  if (typeof limit !== 'number') {
    return null
  }

  // return `当前会员允许每日最大下载次数为${limit}次，请您联系客服进行下载。`
  return `单日会员下载次数限制为${limit}次`
}
